"use strict";

function extend() {
    var obj = arguments[0],
        processor = false,
        startIndex = 1;
    if (obj === true || obj === 'deepcopy') {
        processor = _deepcopy;
        obj = arguments[startIndex];
        startIndex++;
    }
    if (typeof obj === 'function') {
        processor = obj;
        obj = arguments[startIndex];
        startIndex++;
    }
    for (var i = startIndex; i < arguments.length; i++) {
        obj = _extend(obj, arguments[i], processor);
    }
    return obj;
}
function _extend(a, b, processor) {
    for (var prop in b) {
        if (b.hasOwnProperty(prop)) {
            if (!( prop === "constructor" && a === window )) {
                if (b[prop] === undefined) {
                    delete a[prop];
                } else {
                    if (processor && typeof processor === 'function') {
                        var value = processor(a[prop], b[prop], function (a, b) {
                            return b;
                        });
                        if (value !== undefined) {
                            a[prop] = value;
                        }
                    } else {
                        a[prop] = b[prop];
                    }
                }
            }
        }
    }
    return a;
}
function _deepcopy(a, b, defaultProcessor) {
    if (typeof a === 'object' && typeof b === 'object') {
        return extend(true, a, b);
    } else {
        return defaultProcessor(a, b);
    }
}
function format(string, obj) {
    var result = string;
    if (!(obj instanceof Object) || arguments.length > 2) {
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        obj = args;
    }
    for (var name in obj) {
        if (obj.hasOwnProperty(name)) {
            result = replaceToken(result, name, obj[name]);
        }
    }
    return result;
}
function replaceToken(string, tokenName, value) {
    var pattern = new RegExp("{\\s*?" + tokenName + "\\s*?\\}", "ig");
    if (string && pattern.test(string)) {
        string = string.replace(pattern, value);
    }
    return string;
}
function trim(string) {
    if (!string) {
        return string;
    }
    return string.replace(/^\s+|\s+$/gm,'');
}
function join () {
    var str = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
        str = _join(str, arguments[i]);
    }
    return str;
}
function _join (pathLeft, pathRight) {
    if (!pathLeft) {
        return pathRight;
    }
    if (!pathRight) {
        return pathLeft;
    }
    if (pathLeft[pathLeft.length - 1] === '/' || pathLeft[pathLeft.length - 1] === '\\') {
        pathLeft = pathLeft.substring(0, pathLeft.length - 1);
    }
    if (pathRight[0] !== '/' && pathRight[0] !== '\\') {
        pathRight = '/' + pathRight;
    }
    return pathLeft + pathRight;
}
function bindArgs(func) {
    var args = [];
    for (var i = 1; i < arguments.length; i++) {
        args.push(arguments[i]);
    }
    return function () {
        var funcArgs = [];
        for (var i = 0; i < args.length; i++) {
            funcArgs.push(args[i]);
        }
        for (i = 0; i < arguments.length; i++) {
            funcArgs.push(arguments[i]);
        }
        return func.apply(this, funcArgs);
    };
}
function memorize(func, hasher) {
    var wrapper = function(key) {
        var cache = wrapper.cache;
        var cache_key = '' + (hasher ? hasher.apply(this, arguments) : key);
        if (!cache.hasOwnProperty(cache_key)) {
            cache[cache_key] = func.apply(this, arguments);
        }
        return cache[cache_key];
    };
    wrapper.cache = {};
    return wrapper;
}
function ctMixpanelCommonProps (course) {
    return {
        'CourseName' : course.name,
        'CourseProvider' : course.platform_name,
        'CourseRating' : course.rating,
        '# of Reviews' : course.reviews_count
    };
}
module.exports = {
    extend: extend,
    format: format,
    join: join,
    bindArgs: bindArgs,
    ct_mixpanel_props: ctMixpanelCommonProps,
    memorize: memorize,
    trim: trim
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/@axd/widgets-utils/index.js
 ** module id = 9
 ** module chunks = 0
 **/